module.exports = __webpack_public_path__ + "static/media/bangles.386e3e81.jpg";